<template>
  <UMarquee :repeat="2" :ui="{ root: '[--duration:50s]' }">
    <NuxtImg
      v-for="index in 27"
      :key="index"
      provider="s3Provider"
      :src="`/home/logoHoteles/${index + 1}.svg`"
      alt="Logo hoteles"
      loading="lazy"
      width="80"
      height="40"
      class="grayscale opacity-50 mr-16 md:mr-28 py-6 shrink-0"
    />
  </UMarquee>
</template>
